/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { localize } from 'commons/LocalizedText/LocalizedText';
import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';

const useStyles = makeStyles((theme) => ({
  noNotes:{
    margin: 0,
    color: theme.palette.text.disabled,
    width: '15em'
  },
  titleNote:{
    margin: 0,
    color: theme.palette.text.disabled
  },
  note:{
    cursor: 'pointer',
    marginLeft: 15,
    overflow: 'auto',
    whiteSpace: 'nowrap',
    color: theme.palette.primary.hover,
    "&:hover": {
      background: theme.palette.primary.tableHover,
      textDecorationLine: 'underline'
    }
  },
  noteProgess:{
    margin: 20
  },
  noteBluePart: {
    color: theme.palette.primary.main
  }
}));

const NoteListComponent = ({data, displayNotes, isLoading, setDisplayNotes, title}) => {
  const classes = useStyles();
  const { laboratory: laboratoryId } = useParams();
  const location = useLocation();
  const history = useHistory();

  const handleOnSelectTestNumber = testNumber => {
    setDisplayNotes(!displayNotes);
    history.push(
      GENERATE_ROUTE(ROUTES.TEST.BASE,
        { laboratory: laboratoryId, ptldId: testNumber }
      ),
      { displayNote: true, isNewTestNumber: !location.pathname.includes(testNumber)}
    );
  }

  return (
    <Grid item>
      {data && data.length > 0 ?
        (
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <h4 className={classes.titleNote}>
                {localize(title)}
              </h4>
            </Grid>
            {(!isLoading && data) ?
              <Grid item>
                <Grid container direction='column' spacing={1}>
                  {data.map(r =>
                    <Grid
                      className={classes.note}
                      item
                      key={r.testNumber}
                      onClick={() => handleOnSelectTestNumber(r.ptldRecid)}
                    >
                      {`${r.testNumber} - ${r.ptldStatus} - ${r.notesCount} ${localize('newNotes')}`}
                    </Grid>
                  )}
                  {data.length > 25 &&
                    <Grid item style={{ marginLeft: '15px' }}>
                      ...
                    </Grid>
                  }
                </Grid>
              </Grid>
              :
              <LinearProgress className={classes.noteProgess}/>}
          </Grid>
        ):(
          <h4 className={classes.noNotes}>{localize('noNotes')}</h4>
        )
      }
    </Grid>
  );
};

export default NoteListComponent;